// ResourceHeaderCreate.js
import { Button, TextField } from '@mui/material';
import React, { useState } from 'react';

function ResourceHeaderCreate({ onResourceCreated }) {
  const [newResource, setNewResource] = useState({
    name: '',
    // Agrega otros campos si es necesario
  });

  const [createIsLoading, setCreateIsLoading]= useState(false);

  const handleCreateResource = async () => {
    setCreateIsLoading(true);
    await onResourceCreated(newResource);
    setCreateIsLoading(false);
    setNewResource({ name: ''});
  };

  return (
    <div style={{margin: "0 0 1em 0"}}>
      <h4 style={{ margin: "0 0 1em 0", fontWeight: '600' }} >Create New Header</h4>
      <TextField
        style={{margin: "0 1em 0 0"}}
        type="text"
        placeholder="Resource Name"
        value={newResource.name}
        onChange={(e) => setNewResource({ ...newResource, name: e.target.value })}
      />
      {/* Agrega campos de entrada adicionales para otras propiedades del recurso */}
      <Button variant="contained" onClick={handleCreateResource} disabled={createIsLoading} style={{width: "100px"}}>Create</Button>
    </div>
  );
}

export default ResourceHeaderCreate;